import React, { useCallback } from 'react';

import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import HourlyTrackerColumnPicker from 'scenes/Trackers/HourlyTracker/components/HourlyTrackerColumnPicker';
import { useExportHourlyTracker } from 'scenes/Trackers/HourlyTracker/hooks';
import {
  SET_COLOR_SCALES_ALL_COLUMNS,
  SET_COLUMNS,
} from 'scenes/Trackers/HourlyTracker/reducers';
import { APPLY } from 'scenes/Trackers/Tracker/reducers';

import Actions from './Actions';

const HourlyTrackerActions = ({ disabledExport }) => {
  const [content, setContent] = useChildComponent();
  const exportHourlyTracker = useExportHourlyTracker();
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const handleCustomizeColumns = () => {
    setContent(HourlyTrackerColumnPicker, {
      value: screenState.temporary?.columns?.order || screenState.columns.order,
      onSubmit: ({ order, apply }) => {
        const action = {
          type: SET_COLUMNS,
          payload: {
            collapsed: screenState.columns.collapsed,
            order,
          },
        };
        if (apply) {
          dispatch({
            type: APPLY,
            payload: action,
          });
        } else {
          dispatch(action);
        }
      },
    });
  };
  const handleExport = useCallback(async () => {
    const {
      filtersCollection,
      tableSettings,
      searchQuery,
      drillPath,
      columns,
    } = screenState;

    await exportHourlyTracker({
      filtersCollection,
      tableSettings: {
        ...tableSettings,
        limit: 10000,
      },
      searchQuery,
      drillPath,
      columns,
    });
  }, [exportHourlyTracker, screenState]);

  const handleToggleColorScales = useCallback(() => {
    dispatch({
      type: SET_COLOR_SCALES_ALL_COLUMNS,
      payload: !screenState?.columns?.isAllScaled,
    });
  }, [screenState?.columns?.isAllScaled]);

  return (
    <React.Fragment>
      <Actions
        onExport={handleExport}
        onCustomizeColumns={handleCustomizeColumns}
        disabledExport={disabledExport}
        colorScaled={screenState?.columns?.isAllScaled}
        onToggleColorScales={handleToggleColorScales}
      />
      {content}
    </React.Fragment>
  );
};

export default HourlyTrackerActions;
